import { render, staticRenderFns } from "./baobei.vue?vue&type=template&id=7225229b&"
import script from "./baobei.vue?vue&type=script&lang=js&"
export * from "./baobei.vue?vue&type=script&lang=js&"
import style0 from "./baobei.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7225229b')) {
      api.createRecord('7225229b', component.options)
    } else {
      api.reload('7225229b', component.options)
    }
    module.hot.accept("./baobei.vue?vue&type=template&id=7225229b&", function () {
      api.rerender('7225229b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/xinfang/baobei.vue"
export default component.exports